export const ADD_FERPA = 'ADD_FERPA';
export const DELETE_FERPA = 'DELETE_FERPA';
